import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import ListaClientes from "../../Componentes/ListaClientes";
import FiltroServico from "../../Componentes/FiltroServico";
import { useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import "./styles.css";

const Menu = () => {
  const { resetaVariaveis } = usePentagovContext();
  const { isAuthenticated, authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();
  const navigate = useNavigate();
  const [Clientes, setClientes] = useState([]);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);

  const idFormatado = String(IDOperador).padStart(6, "0");

  useEffect(() => {
    if (operador && operador.IDOperador && isAuthenticated && authReady) {
      const carregarTela = async () => {
        resetaVariaveis();

        const retorno = await buscaClientes(IDOperador, processoSelecionado);

        if (retorno && retorno.data && Array.isArray(retorno.data.Clientes)) {
          setClientes(retorno.data.Clientes);
        } else {
          setClientes([]);
        }
      };

      carregarTela();
    } else {
      navigate("/");
    }
  }, [operador, processoSelecionado, isAuthenticated, authReady, navigate, IDOperador, resetaVariaveis]);

  async function buscaClientes(idOperador, processo) {
    try {
      let url = `/clientes/operador/${idOperador}`;

      if (processo && processo.trim() !== "") {
        url += `/${processo}`;
      }

      const response = await api.get(url);
      return response;
    } catch (error) {
      return error;
    }
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <div className="page-shell">
          <MenuSuperior userId={idFormatado} userName={nome} />

          <FiltroServico
            valorSelecionado={processoSelecionado}
            onChange={setProcessoSelecionado}
          />

          <section className="page-section-card menu-list-section">
            <ListaClientes lista={Clientes || []} />
          </section>
        </div>
      </div>
    </div>
  );
};

export default Menu;
